import { Svg } from 'components/svg'
import { IconType } from 'models'

export const IconHomeOutline: IconType = ({ className = '' }) => (
  <Svg className={className} viewBox="0 0 24 24" fill="none">
    <path
      d="M19 22H5C4.44772 22 4 21.5523 4 21V13H2L11.292 3.707C11.4796 3.51922 11.7341 3.41371 11.9995 3.41371C12.2649 3.41371 12.5194 3.51922 12.707 3.707L22 13H20V21C20 21.5523 19.5523 22 19 22ZM10 15H14V20H18V11.828L12 5.828L6 11.828V20H10V15Z"
      fill="currentColor"
    />
  </Svg>
)
